import template from './managed_department_search_component.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ManagedDepartmentSearchComponentViewModel
{
	constructor (params)
	{
		this.params = params;

		this.departments = ko_helper.safe_observableArray();
		this.selected_department = ko_helper.safe_observable(params.selected_department || '');
		this.search_string = ko.observable('');

		// Computed observable for dynamically updating the placeholder
		this.placeholderText = ko.pureComputed(() => {
			return this.selected_department() != null ? `Selected department: ${this.selected_department().department} (${this.selected_department().company})` : "Search department...";
		});

		this.search_string.subscribe((newValue) => {
			this.updateData();
		});
	}

	async init()
	{
		await this.updateData();
	}

	async updateData()
	{
		if (!Permissions.isLoggedInUser_Admin())
		{
			let user_id = Utils.current_employee_id()
			if (!user_id)
			{
				Grape.alerts.alert({type: 'error', message: tr('Failed to get current user id'), title: tr('Error')});
				return;
			}

			let options = {
				table: 'v_manager_department',
				schema: 'savanna',
				limit: 10000,
				filter_join: 'AND',
				filter: [{ value: user_id, operand: '=', field: 'employee_id' }],
				sortfield: 'department',
				sortorder: 'asc'
			};

			if (this.search_string() && this.search_string() != '')
			{
				let result = await Grape.fetches.getJSON('/api/record', options);
				if (result.status != 'ERROR' && result.records != null)
				{
					// Remove duplicates of department_id
					let departments = result.records.reduce((acc, current) => {
						if (!acc.find(item => item.department_id === current.department_id))
							acc.push(current);

						return acc;
					}, []);

					// this is front end search... Never do this, only doing it now because of the data (an employee will never have so many departments that will cause a lag)
					// TODO: rather find a different way to do this.. like a api with a function that does the search in the backend function.
					if (this.search_string() && this.search_string() != '')
					{
						departments = departments.filter(dept => 
							dept.department.toLowerCase().includes(this.search_string().toLowerCase()) || 
							dept.company.toLowerCase().includes(this.search_string().toLowerCase())
						);
					}
					this.departments(departments);
				}
			}
			else
				this.departments([]);
		}
		else
		{
			let options = {
				table: 'v_department_company',
				schema: 'savanna',
				limit: 10000,
				filter_join: 'OR',
				filter: [],
				sortfield: 'department',
				sortorder: 'asc'
			};

			if (this.search_string() && this.search_string() != '')
			{
				options.filter.push({
					field: 'department',
					operand: 'ILIKE',
					value: `%${this.search_string()}%`,
				});

				options.filter.push({
					field: 'company',
					operand: 'ILIKE',
					value: `%${this.search_string()}%`,
				});

				let result = await Grape.fetches.getJSON('/api/record', options);
				if (result.status != 'ERROR')
					if (result.records != null)
						this.departments(result.records);
			}
			else
				this.departments([]);
		}
	}

	department_click (selected)
	{
		this.selected_department(selected);
		this.search_string('');
	}

	clear_selected_option ()
	{
		this.selected_department(null);
		this.search_string('');
	}
}

export default {
	name: 'managed_department_search_component',
	viewModel: ManagedDepartmentSearchComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/managed_department_search_component'
};
